enum ConfidenceQuestionCategory {
	ANIMALS = "Animals",
	HISTORICAL_FIGURES = "Historical Figures",
	DEMOGRAPHICS = "Demographics",
	SCIENCE = "Science",
	FOOD = "Food",
	LITERATURE = "Literature",
	INVENTIONS = "Inventions"
}

export default ConfidenceQuestionCategory;